import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import AppRoutes from "./routes/AppRoutes";
import AnimatedBackground from "./components/AnimatedBackground";
import BackgroundVideo from "./components/BackgroundVideo";
import useGoogleAnalytics from "./hooks/useGoogleAnalytics";
import useSentryMonitoring from "./hooks/useSentryMonitoring";
import usePerformanceMonitoring from "./hooks/usePerformanceMonitoring";
import ChatWidget from "./components/ChatWidget";
import WhatsAppButton from "./components/WhatsAppButton";

export default function App() {
  // Initialize monitoring and analytics
  useGoogleAnalytics();
  useSentryMonitoring();
  usePerformanceMonitoring();

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden">
      {/* Background video - z-index: 0 */}
      <BackgroundVideo />

      {/* Animated particle background - z-index: 0 */}
      <AnimatedBackground />
      
      {/* Gradient overlays for depth - z-index: 2, pointer-events-none */}
      <div className="fixed inset-0 bg-linear-to-br from-amber-700/30 via-orange-600/25 to-amber-500/25 z-2 pointer-events-none" />
      <div className="fixed inset-0 bg-[radial-gradient(circle_at_25%_15%,rgba(251,191,36,0.08),transparent_55%)] z-2 pointer-events-none" />
      <div className="fixed inset-0 bg-[radial-gradient(circle_at_75%_85%,rgba(245,158,11,0.1),transparent_55%)] z-2 pointer-events-none" />
      
      {/* Navbar - z-index: 100000+ (needs to be outside main content stacking context) */}
      <Navbar />
      
      {/* Main Content - z-index: 10 (above backgrounds, below navbar) */}
      <div className="relative z-10 flex flex-col min-h-screen pointer-events-auto">
        <main className="flex-1">
          <div className="page">
            <AppRoutes />
          </div>
        </main>
        <Footer />
      </div>

      {/* Chat Widget - z-index: 40-50 */}
      <ChatWidget />

      {/* WhatsApp Button - z-index: 40 */}
      <WhatsAppButton />
    </div>
  );
}
